function isMobileOrTablet() {
    // User-Agent Detection
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);

    // Touch Capability Detection
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    // Screen Size Check
    const isSmallScreen = window.innerWidth <= 800; // Adjust according to your needs

    return isMobileUserAgent || isTouchDevice || isSmallScreen;
}

function toggleCardAnimation(card) {
    card.classList.toggle('is-flipped');
}

document.addEventListener("DOMContentLoaded", () => {
    if (isMobileOrTablet()) {
        const cards = document.querySelectorAll('.animated-card');
        cards.forEach(card => {
            card.classList.add('no-hover');
            card.addEventListener('click', function() {
                toggleCardAnimation(card);
            });
        });
    }
});